<template>
	<div id="page_download">
		<el-container style="border: 0px solid #FF0000; padding:0px; margin: 0px;" v-if="!isWeChat">
			<el-header style="height:2px;">&nbsp;</el-header>
			<el-main>
				<el-row>
					<div style="margin-top: 2px; margin-bottom: 10px; font-size: 18px; font-weight: 600;">
						{{title}}
					</div>
				</el-row>
				<el-row>
					<div>
						<img style="margin-top: 5px; margin-bottom: 5px; width:50%;" src="../assets/download_page_bg_001.png">
					</div>
				</el-row>
				<el-row :gutter="10">
					<el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="isDisplayWindows">
						<div class="grid-content">
							<div>
								<el-card :body-style="{ padding: '5px' }" shadow="hover">
									<div style="font-weight: 600;color: rgba(33,33,33,0.7);">{{windowsClientLabel}}</div>
									<img style="margin-top: 5px;" src="../assets/windows.png">
									<div style="padding: 10px;font-size: 10px;">
										<div>{{app4WindowsVersion}}</div>
										<div>{{app4WindowsSystemVersionDesc}}</div>
									</div>
									<el-button type="primary" size="small" @click="downloadApp(app4WindowsUrl)">{{downloadWindowsClientLabel}}</el-button>
								</el-card>
							</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="isDisplayAndroid">
						<div class="grid-content">
							<el-card :body-style="{ padding: '5px' }" shadow="hover">
								<div style="font-weight: 600;color: rgba(33,33,33,0.7);">{{androidClientLabel}}</div>
								<img style="margin-top: 5px;" src="../assets/android.png">
								<div style="padding: 10px;font-size: 10px;">
									<div>{{app4AndroidVersion}}</div>
									<div>{{app4AndroidSystemVersionDesc}}</div>
								</div>
								<el-button type="primary" size="small" @click="downloadApp(app4AndroidUrl)">{{downloadAndroidClientLabel}}</el-button>
							</el-card>
						</div>
					</el-col>
					<el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="isDisplayIos">
						<div class="grid-content">
							<el-card :body-style="{ padding: '5px' }" shadow="hover">
								<div style="font-weight: 600;color: rgba(33,33,33,0.7);">{{iosClientLabel}}</div>
								<img style="margin-top: 5px;" src="../assets/ios.png">
								<div style="padding: 10px;font-size: 10px;">
									<div>&nbsp;{{app4iOSVersion}}</div>
									<div>{{app4iOSSystemVersionDesc}}</div>
								</div>
								<el-button type="primary" @click="downloadIos(app4iOSUrl)" size="small" >{{downloadIosClientLabel}}</el-button>
							</el-card>
						</div>
					</el-col>
					<el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="isDisplayMac">
						<div class="grid-content">
							<el-card :body-style="{ padding: '5px' }" shadow="hover">
								<div style="font-weight: 600;color: rgba(33,33,33,0.7);">{{macClientLabel}}</div>
								<img style="margin-top: 5px;" src="../assets/mac.png">
								<div style="padding: 10px;font-size: 10px;">
									<div>{{app4MacVersion}}</div>
									<div>{{app4MacSystemVersionDesc}}</div>
								</div>
								<el-button type="primary" size="small" @click="downloadApp(app4MacUrl)">{{downloadMacClientLabel}}</el-button>
							</el-card>
						</div>
					</el-col>
					<el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="isDisplayChromeOS">
						<div class="grid-content">
							<el-card :body-style="{ padding: '5px' }" shadow="hover">
								<div style="font-weight: 600;color: rgba(33,33,33,0.7);">{{chromeOSClientLabel}}</div>
								<img style="margin-top: 5px;" src="../assets/chromeos.png">
								<div style="padding: 10px;font-size: 10px;">
									<div>{{app4ChromeOSVersion}}</div>
									<div>{{app4ChromeOSSystemVersionDesc}}</div>
								</div>
								<el-button type="primary" size="small" @click="downloadApp(app4ChromeOSUrl)">{{downloadChromeOSClientLabel}}</el-button>
							</el-card>
						</div>
					</el-col>
				</el-row>
			</el-main>
			<el-footer style="height:15vh;font-size: 14px;">
				<p v-if="isDisplayBeian"><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备14024048号</a></p>
			    <p v-if="isDisplayCopyright">Copyright © 2024 Lango All Rights Reserved</p>
			</el-footer>
		</el-container>
		<img src="../assets/wechat_mask_ios.jpg" class="mask"  v-else-if="isIOS"/>
		<img src="../assets/wechat_mask_android.png" class="mask"  v-else/>
	</div>
</template>

<script>
	import Ajax from "@/components/Ajax";

	let propertiesMap = {};
	const i18n = {};
	i18n.prop = function(key) {
		return propertiesMap[key];
	};

	const i18n_en = {};

	i18n["en"] = i18n_en;
	i18n_en["title"] = "Airgo Cast";
	i18n_en["windows.client.label"] = "Windows";
	i18n_en["download.windows.client.label"] = "Download";
	i18n_en["android.client.label"] = "Android";
	i18n_en["download.android.client.label"] = "Download";
	i18n_en["ios.client.label"] = "iOS";
	i18n_en["download.ios.client.label"] = "Download";
	i18n_en["tips.ios.client"] = "Please use the Airplay (screen mirror).";
	i18n_en["mac.client.label"] = "Mac";
	i18n_en["download.mac.client.label"] = "Download";
	i18n_en["chromeos.client.label"] = "Chrome OS";
	i18n_en["download.chromeos.client.label"] = "Download";

	const i18n_zh = {};

	i18n["zh"] = i18n_zh;
	i18n_zh["title"] = "Airgo Cast无线投屏";
	i18n_zh["windows.client.label"] = "Windows客户端";
	i18n_zh["download.windows.client.label"] = "下载Windows版";
	i18n_zh["android.client.label"] = "Android客户端";
	i18n_zh["download.android.client.label"] = "下载Android版";
	i18n_zh["ios.client.label"] = "iOS客户端";
	i18n_zh["download.ios.client.label"] = "下载iOS版";
	i18n_zh["tips.ios.client"] = "请使用Airplay（屏幕镜像）投屏";
	i18n_zh["mac.client.label"] = "Mac客户端";
	i18n_zh["download.mac.client.label"] = "下载Mac版";
	i18n_zh["chromeos.client.label"] = "Chrome OS客户端";
	i18n_zh["download.chromeos.client.label"] = "下载Chrome OS版";

	export default {
		name: 'app',
		components: {},
		data() {
			return {
				currentLanguage: "zh",
				isDisplayWindows: true,
				isDisplayAndroid: true,
				isDisplayIos: true,
				isDisplayMac: true,
				isDisplayChromeOS: true,
				isDisplayBeian: false,
				isDisplayCopyright: false,
				title: "",
				app4WindowsVersion: "",
				app4WindowsSystemVersionDesc: "",
				app4WindowsUrl: "",
				app4MacVersion: "",
				app4MacSystemVersionDesc: "",
				app4MacUrl: "",
				app4AndroidVersion: "",
				app4AndroidSystemVersionDesc: "",
				app4AndroidUrl: "",
				app4iOSVersion: "",
				app4iOSSystemVersionDesc: "",
				app4iOSUrl: "",
				app4ChromeOSVersion: "",
				app4ChromeOSSystemVersionDesc: "",
				app4ChromeOSUrl: "",
				windowsClientLabel: "Windows",
				downloadWindowsClientLabel: "Download",
				androidClientLabel: "Android",
				downloadAndroidClientLabel: "Download",
				iosClientLabel: "IOS",
				downloadIosClientLabel: "Developing, Please look forward to.",
				tipsIosClient: "Use the Airplay (screen mirror) for screen share.",
				macClientLabel: "Mac",
				downloadMacClientLabel: "Download",
				chromeOSClientLabel: "Chrome OS",
				downloadChromeOSClientLabel: "Download",
				appList:[]
			};
		},
		computed:{
			isWeChat:function(){
				let ua = navigator.userAgent.toLowerCase();
				let isWeChat =  ua.match(/MicroMessenger/i) == 'micromessenger';
				if(isWeChat){
					document.getElementsByTagName("body")[0].style = "width:100%;height:100%;margin:0px;padding:0px;";
					document.getElementById("app").style = "width:100%;height:100%;";
				}
				return isWeChat
			},
			isIOS:function(){
				return /(iPhone|iPad|iPod|IOS)/i.test(navigator.userAgent);
			},
			isChinese:function(){
                return "zh" == this.currentLanguage;
			}
		},
		methods: {
			getAppList() {
				let vm = this;

                let currLang = vm.getLanguage();
				vm.currentLanguage = currLang;

				let reqParams = {};
				console.log("getAppList");

				Ajax.get({
					get: {
						url: "/conf_v3.json",
						data: reqParams
					},
					then: function(res) {
						vm.appList = res;

						vm.appList.forEach(function(item) {
							if (item.system == "windows") {
								vm.app4WindowsVersion = item.version;
								vm.app4WindowsSystemVersionDesc = JSON.parse(item.systemVersionDesc)[currLang];
								vm.app4WindowsUrl = item.url;
								if (item.display !== undefined) {
                                    vm.isDisplayWindows = item.display;
								} else {
									vm.isDisplayWindows = true;
								}
							} else if (item.system == "mac") {
								vm.app4MacVersion = item.version;
								vm.app4MacSystemVersionDesc = JSON.parse(item.systemVersionDesc)[currLang];
								vm.app4MacUrl = item.url;
								if (item.display !== undefined) {
									vm.isDisplayMac = item.display;
								} else {
									vm.isDisplayMac = true;
								}
							} else if (item.system == "android") {
								vm.app4AndroidVersion = item.version;
								vm.app4AndroidSystemVersionDesc = JSON.parse(item.systemVersionDesc)[currLang];
								vm.app4AndroidUrl = item.url;
								if (item.display !== undefined) {
									vm.isDisplayAndroid = item.display;
								} else {
									vm.isDisplayAndroid = true;
								}
							} else if (item.system == "iOS") {
                                vm.app4iOSVersion = item.version;
                                vm.app4iOSSystemVersionDesc = JSON.parse(item.systemVersionDesc)[currLang];
                                vm.app4iOSUrl = item.url;
                                if (item.display !== undefined) {
                                    vm.isDisplayIos = item.display;
                                } else {
                                    vm.isDisplayIos = true;
                                }
                            } else if (item.system == "Chrome OS") {
                                vm.app4ChromeOSVersion = item.version;
                                vm.app4ChromeOSSystemVersionDesc = JSON.parse(item.systemVersionDesc)[currLang];
                                vm.app4ChromeOSUrl = item.url;
                                if (item.display !== undefined) {
                                    vm.isDisplayChromeOS = item.display;
                                } else {
                                    vm.isDisplayChromeOS = true;
                                }
                            }
				        });
					}
				});
			},
			downloadApp(url) {
				console.info("app url:" + url);
				window.location.href = url;
			},
            // 跳转ios应用下载页面
            downloadIos(url) {
                // window.open(url)
				window.location.href = url;
            },
			loadProperties(lang) {
				propertiesMap = i18n[lang];

				window.document.title = propertiesMap["title"];
				this.title = propertiesMap["title"];
				this.windowsClientLabel = propertiesMap["windows.client.label"];
				this.downloadWindowsClientLabel = propertiesMap["download.windows.client.label"];
				this.androidClientLabel = propertiesMap["android.client.label"];
				this.downloadAndroidClientLabel = propertiesMap["download.android.client.label"];
				this.iosClientLabel = propertiesMap["ios.client.label"];
				this.downloadIosClientLabel = propertiesMap["download.ios.client.label"];
				this.tipsIosClient = propertiesMap["tips.ios.client"];
				this.macClientLabel = propertiesMap["mac.client.label"];
				this.downloadMacClientLabel = propertiesMap["download.mac.client.label"];
				this.chromeOSClientLabel = propertiesMap["chromeos.client.label"];
				this.downloadChromeOSClientLabel = propertiesMap["download.chromeos.client.label"];
			},
			getLanguage() {
				let result = "en";
				let lang = (navigator.language || navigator.browserLanguage).toLowerCase();
				console.info("当前语言 " + lang);

				if (lang.indexOf('zh') >= 0) {
					// 假如浏览器语言是中文
					result = "zh";
				} else if (lang.indexOf('en') >= 0) {
					// 假如浏览器语言是英文
					result = "en";
				}
				//else if (lang.indexOf('ja') >= 0) {
					// 假如浏览器语言是日语
					//result = "ja";
				//} 
				else {
					// 假如浏览器语言是其它语言
					result = "en";
				}
				return result;
			},
			getBrowser() {
				let UserAgent = navigator.userAgent.toLowerCase();
				let browserInfo = {};
				let browserArray = {
					IE: window.ActiveXObject || "ActiveXObject" in window, // IE
					Chrome: UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1, // Chrome浏览器
					Firefox: UserAgent.indexOf('firefox') > -1, // 火狐浏览器
					Opera: UserAgent.indexOf('opera') > -1, // Opera浏览器
					Safari: UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') == -1, // safari浏览器
					Edge: UserAgent.indexOf('edge') > -1, // Edge浏览器
					QQBrowser: /qqbrowser/.test(UserAgent), // qq浏览器
					WeixinBrowser: /MicroMessenger/i.test(UserAgent) // 微信浏览器
				};
				// console.log(browserArray)
				for (let i in browserArray) {
					if (browserArray[i]) {
						let versions = '';
						if (i == 'IE') {
							versions = UserAgent.match(/(msie\s|trident.*rv:)([\w.]+)/)[2];
						} else if (i == 'Chrome') {
							for (let mt in navigator.mimeTypes) {
								//检测是否是360浏览器(测试只有pc端的360才起作用)
								if (navigator.mimeTypes[mt]['type'] == 'application/360softmgrplugin') {
									i = '360';
								}
							}
							versions = UserAgent.match(/chrome\/([\d.]+)/)[1];
						} else if (i == 'Firefox') {
							versions = UserAgent.match(/firefox\/([\d.]+)/)[1];
						} else if (i == 'Opera') {
							versions = UserAgent.match(/opera\/([\d.]+)/)[1];
						} else if (i == 'Safari') {
							versions = UserAgent.match(/version\/([\d.]+)/)[1];
						} else if (i == 'Edge') {
							versions = UserAgent.match(/edge\/([\d.]+)/)[1];
						} else if (i == 'QQBrowser') {
							versions = UserAgent.match(/qqbrowser\/([\d.]+)/)[1];
						}

						browserInfo.type = i;
						browserInfo.versions = parseInt(versions);
					}
				}
				this.dialogVisible = true;
				return browserInfo;
			}
		},
		mounted() {
			console.log(this.isWeChat);
			let vm = this;

			if (this.isIOS) {
				let url = "https://apps.apple.com/app/apple-store/id1625799939";
                this.downloadIos(url);
				// return;
			}

			let currLang = vm.getLanguage();

			vm.loadProperties(currLang);

			this.getAppList();
		}
	}
</script>

<style>
	.el-col {
		border-radius: 4px;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 240px;
	}

	.el-footer a:link,
	.el-footer a:hover,
	.el-footer a:active,
	.el-footer a:visited {
		color: #000000;
		font-weight: bold;
	}
	.mask{
		width: 100%;
		height: 100%;
	}
</style>